import { render, staticRenderFns } from "./addGs.vue?vue&type=template&id=04e6a0d0&"
import script from "./addGs.vue?vue&type=script&lang=js&"
export * from "./addGs.vue?vue&type=script&lang=js&"
import style0 from "./addGs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports